<template>
  <div
    class="rounded aha-banner-success flex items-center justify-center"
  >
    <div
      class="inline-flex justify-center items-center p-2"
    >
      <TickSvg class="flex-shrink-0 mr-1 aha-success-icon" :color="'#33C173'" />

      <span class="text-base text-secondary-100 ">
        <slot />
      </span>
    </div>
  </div>
</template>

<script>

import TickSvg from '@/components-v2/my-plan/user-pricing-v3/TickSvg.vue'

export default {
  components: { TickSvg },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-banner-success {
  background:var(--secondary-10, #EBF9F1);
  color: #282E3E;
  font-size: 16px;
}

.aha-success-icon {
  color:#33C173;
}

</style>
